type IconPathMap = {
    [key: string]: string;
};

const iconPathMap: IconPathMap = {
    cart: '/cpc/icons/',
    // Add other exceptions here in the future
};

export function getIconSrc(pageType: string, name: string): string {
    const customPath = iconPathMap[pageType];

    if (customPath) {
        return `${customPath}${name}.png`;
    }

    return `/${pageType}/icons/${name}.png`;
}
